import { FilterScopeProvider, ResetAllFiltersButton, usePlayerFilterOptions } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { playerIdAtom } from '@/atoms/player/player';
import { PlayerFilterTabs } from '@/components/player/filters/PlayerFilterTabs';
import { useComparisonFilterTabsActive } from '@/hooks/useComparisonFilterTabsActive';
import { LayoutWithFilters } from '../LayoutWithFilters';

const PlayerLayoutWithFiltersContent = ({
  children,
  settingsPanel,
  insightComponent,
}: {
  children: ReactNode;
  settingsPanel?: ReactNode;
  insightComponent?: ReactNode;
}) => {
  const { t } = useTranslation(['general']);
  const tabsActive = useComparisonFilterTabsActive();
  usePlayerFilterOptions(useAtomValue(playerIdAtom));
  return (
    <LayoutWithFilters
      filters={<PlayerFilterTabs />}
      filtersTitle={t('filters.other', { ns: 'general' })}
      filtersActions={tabsActive ? undefined : <ResetAllFiltersButton />}
      settingsPanel={settingsPanel}
      insightComponent={insightComponent}
    >
      {children}
    </LayoutWithFilters>
  );
};

export const PlayerLayoutWithFilters = (props: {
  children: ReactNode;
  settingsPanel?: ReactNode;
  insightComponent?: ReactNode;
}) => (
  <FilterScopeProvider scope="main">
    <PlayerLayoutWithFiltersContent {...props} />
  </FilterScopeProvider>
);
